import { render, staticRenderFns } from "./EnquireModalNormalised.vue?vue&type=template&id=0a70b810&"
import script from "./EnquireModalNormalised.vue?vue&type=script&lang=js&"
export * from "./EnquireModalNormalised.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports